import { withCompInfo } from '@wix/editor-elements-integrations'
import { getScaledFont } from '@wix/thunderbolt-becky-root'
import { DatePickerCssCarmiData, DatePickerDefinition } from '@wix/thunderbolt-components-native'

export const css = withCompInfo<DatePickerCssCarmiData, DatePickerDefinition>()(
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	['compProps', 'compLayout', 'styleProperties', 'siteFonts', 'isMobileView', 'isOneDocMigrated'],
	// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
	({ compProps, compLayout, styleProperties, siteFonts, isMobileView, isOneDocMigrated }) => {
		const compInfo = { compLayout, compProps, styleProperties, siteFonts, isMobileView }
		return {
			'--fntlbl': getScaledFont(compInfo, 'fntlbl', isOneDocMigrated, compProps.labelMobileFontSize, 16),
			'--fnt': getScaledFont(compInfo, 'fnt', isOneDocMigrated, compProps.inputMobileFontSize, 13),
		}
	}
)
